<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-dcou-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-dcou-' + id"
    :aria-controls="'collapse-dcou-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_DCOU") }}
  .collapse.show(
    :aria-labelledby="'heading-dcou-' + id"
    :id="'collapse-dcou-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group(v-for="item in col")
              .normal-odd-area-oddtype.text-center.mr-0(v-if="moreItems['dcouo'][item] && moreItems['dcouo'][item][7]") {{ $t("m.BT_" + item) }} ({{ moreItems['dcouo'][item][7] }})
              .normal-odd-area-oddtype.text-center.mr-0(v-else) {{ $t("m.BT_" + item) }}
              template(v-if="moreItems['dcouo'][item] && moreItems['dcouo'][item][5] != 0 && moreItems['dcouo'][item][5] != ''")
                OddsItem(:odds="moreItems['dcouo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="dcouo")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["HDO", "HDU", "HAO", "HAU", "DAO", "DAU"],
    }
  }
}
</script>